import { createBrowserRouter } from 'react-router';

import { routes } from '@/app/routes';

export const router = createBrowserRouter(routes);
